import React, { Component } from 'react';
import { Col, Row, Button, Form} from 'reactstrap';
// import { CardElement, injectStripe} from 'react-stripe-elements';
// import StripeCheckout from 'react-stripe-checkout';
import axios from 'axios';
import { forInStatement } from '@babel/types';

export default class CheckoutForm extends Component {
  // constructor(props) {
  //   super(props);
  //   this.state = { complete: false };
  //   // this.submit = this.submit.bind(this);
  // }


  // async submit(ev) {
  //   let { token } = await this.props.stripe.createToken({ name: "Name" });
  //   // let response = await fetch("http://localhost:4001/api/v1/charge", {
  //   //   method: "POST",
  //   //   headers: { "Content-Type": "application/json" },
  //   //   body: {my_id : token.id}
  //   // });


  //   let payload = { my_id: token.id }
  //   axios.post("http://localhost:4001/api/v1/charge", payload)
  //     .then(response => {
  //       if (response.status == 200) {
  //         console.log("success")
  //         console.log(response)
  //         // this.props.setMapHTML(response.data)

  //         // if (response.ok) {
  //         this.setState({ complete: true });
  //         // }
  //       } else {
  //         console.log("failure")
  //         console.log(response)
  //         // this.props.setMapError(`Server returned error code ${response.status}`)
  //       }
  //       // this.props.setMapProcessing(false)
  //     })
  //     .catch(error => {
  //       console.log(error);
  //       // this.props.setMapProcessing(false)
  //       // this.props.setMapError("Unable to reach map server.")
  //     });


  //   // if (response.ok) console.log("Purchase Complete!")

  // }


  render() {
    // if (this.state.complete) return <h1>Purchase Complete</h1>;
    // return (
    //   <div className="checkout">
    //     <p>Would you like to complete the purchase?</p>
    //     <CardElement />
    //     <button onClick={this.submit}>Send</button>
    //   </div>
    // );

    // Do you want to do local pickup?

    // Do you want to do shipping?

    // Do you want 

    
    return(
      <Form>
        <Form>
          {/* <Form.Group as={Col} > */}
            {/* <Form.Label>Email</Form.Label> */}
            <Form.Control type="email" placeholder="Enter email" />
          {/* </Form.Group> */}
        </Form>

        {/* <Form.Group controlId="formGridAddress1">
          <Form.Label>Address</Form.Label>
          <Form.Control placeholder="1234 Main St" />
        </Form.Group>

        <Form.Group controlId="formGridAddress2">
          <Form.Label>Address 2</Form.Label>
          <Form.Control placeholder="Apartment, studio, or floor" />
        </Form.Group>

        <Form.Row>
          <Form.Group as={Col} controlId="formGridCity">
            <Form.Label>City</Form.Label>
            <Form.Control />
          </Form.Group>

          <Form.Group as={Col} controlId="formGridState">
            <Form.Label>State</Form.Label>
            <Form.Control as="select">
              <option>Choose...</option>
              <option>...</option>
            </Form.Control>
          </Form.Group>

          <Form.Group as={Col} controlId="formGridZip">
            <Form.Label>Zip</Form.Label>
            <Form.Control />
          </Form.Group>
        </Form.Row>

        <Form.Group id="formGridCheckbox">
          <Form.Check type="checkbox" label="Check me out" />
        </Form.Group> */}

        <Button variant="primary" type="submit">
          Submit
        </Button>
      </Form>
      // <StripeCheckout
      //   amount="500"
      //   billingAddress
      //   shippingAddress
      //   description="Folding bike"
      //   image="https://jcat.bike/img/micro0.jpg"
      //   locale="auto"
      //   name="jcat.bike/micro"
      //   stripeKey="pk_test_xkbia5SdLYOdJHr7xdv3PSHX00WvD9VIAx"
      //   token={this.submit}
      //   zipCode
      // />
    )
  }
}

// export default injectStripe(CheckoutForm);
// export default CheckoutForm;